(function () {
  function initMediaDots(host) {
    if (!host) return;
    const targetSel = host.getAttribute('data-target');
    const scroller = document.querySelector(targetSel);
    if (!scroller) return;

    // List items = slides
    const slides = Array.from(scroller.children).filter(el => el.nodeType === 1);
    if (slides.length <= 1) {
      host.innerHTML = '';
      host.setAttribute('hidden', '');
      return;
    }

    host.removeAttribute('hidden');
    host.innerHTML = '';
    host.classList.add('media-dots--ready');

    slides.forEach((_, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'media-dots__dot';
      btn.setAttribute('aria-label', 'Go to media ' + (i + 1));
      btn.addEventListener('click', () => {
        slides[i]?.scrollIntoView({ behavior: 'smooth', inline: 'start' });
        setActive(i);
      });
      host.appendChild(btn);
    });

    const dots = Array.from(host.querySelectorAll('.media-dots__dot'));

    function indexFromScroll() {
      // slide whose center is closest to the viewport center
      const center = scroller.scrollLeft + scroller.clientWidth / 2;
      let best = Infinity, active = 0;
      slides.forEach((el, i) => {
        const mid = el.offsetLeft + el.clientWidth / 2;
        const d = Math.abs(mid - center);
        if (d < best) { best = d; active = i; }
      });
      return active;
    }

    function setActive(i) {
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    }

    // Init state
    setActive(indexFromScroll());

    // Update on scroll (throttled by rAF)
    let ticking = false;
    scroller.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setActive(indexFromScroll());
        ticking = false;
      });
    }, { passive: true });

    // Update on resize/orientation
    new ResizeObserver(() => setActive(indexFromScroll())).observe(scroller);
  }

  function initAllDots() {
    document.querySelectorAll('.media-dots[data-target]').forEach(initMediaDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllDots);
  } else {
    initAllDots();
  }

  // Re-init in Theme Editor / dynamic section renders
  document.addEventListener('shopify:section:load', initAllDots);
  document.addEventListener('shopify:section:select', initAllDots);
})();
